<div id="BetSlipUid" class="hide">{{ BetSlipUid }}</div>
<div class="betslip-action">
  <ng-container *ngFor="let message of updatedBetsDisplayMessage">
    <p class="d-block w-100 text-center pt-2">{{message}}</p>
    </ng-container>
  <p *ngIf="updatedBetsDisplayMessage.length > 0 && Bets.length > 0" class="d-block w-100 text-center pt-2">Please confirm and place bet.</p>
  <button class="betslip-btn d-block w-100" id="placebet" (click)="placeBet()" [disabled]="!isPlaceBetEnabled">Place Bet</button>
</div>